<template>
  <div>
    <ml-header title="观看记录" :dark="true" background-color="#fff">
      <p class="clear" @click="clear">清空记录</p>
    </ml-header>
    <div class="watch-history">
      <GridLayoutVideo :videos="videos" />
    </div>
  </div>
</template>

<script>
import GridLayoutVideo from "@/views/video/components/GridLayoutVideo";
import { clearWatchHistories, getWatchHistories } from "@/api/video";

export default {
  name: "WatchHistory",
  components: {
    GridLayoutVideo
  },
  data() {
    return {
      videos: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { content: videos } = await getWatchHistories();
      this.videos = videos.map(item => {
        item.video.duration = item.watchDuration;
        return { ...item.video };
      });
    },
    async clear() {
      await clearWatchHistories();
      this.videos = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.watch-history {
  margin-top: 40px;
  padding: 10px 15px;
}
.clear {
  color: rgba(228, 191, 88, 1);
}
</style>
